import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'
import { logout, login } from 'redux-implicit-oauth2'
import { push } from 'react-router-redux'
import { loginLoggedOut, loginInProgress, loginSuccess, loginFailed } from '../ducks/authStatus'
import { fetchMe } from '../ducks/me'
import config from '../config'
import Component from '../components/Navbar/index'

function mapStateToProps(state) {
  return {
    auth: state.auth,
    authStatus: state.authStatus,
    me: state.me,
    route: state.routing.locationBeforeTransitions.pathname,
    type: state.types.selected,
    project: state.projects.selected,
  }
}

function mapDispatchToProps(dispatch) {
  const actions = {
    loginSuccess,
    loginFailed,
    fetchMe,
    login: () => login(config),
    logout,
    loginLoggedOut,
    loginInProgress,
    push,
  }

  return { actions: bindActionCreators(actions, dispatch) }
}

export default connect(mapStateToProps, mapDispatchToProps)(Component)



// WEBPACK FOOTER //
// ./containers/Navbar.js